var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19H17.375V8.61294H20V19Z",
    fill: "#CF2F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.9172C4 13.532 4.36157 14.0646 4.8855 14.3189C4.74622 14.5513 4.66589 14.8222 4.66589 15.1114C4.66589 15.7776 5.09058 16.3474 5.6864 16.5708C5.5675 16.7899 5.49988 17.0401 5.49988 17.3056C5.49988 18.1661 6.20801 18.8661 7.07849 18.8661H14.235L16.4375 18.0448V9.49755H15.5643L12.6196 6.13012L12.3666 4.75199C12.2865 4.31627 11.9033 4 11.4552 4H10.9136C9.87073 4 9.02222 4.83875 9.02222 5.8696C9.02222 6.51758 9.14832 7.14987 9.39709 7.74934L9.95911 9.16258H6.05225C5.18176 9.16258 4.47351 9.86256 4.47351 10.723C4.47351 11.0453 4.573 11.3452 4.74304 11.5941C4.29724 11.8702 4 12.36 4 12.9172Z",
    fill: "#CF2F92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpFilled);
export default __webpack_public_path__ + "static/media/thumbsUpFilled.27b25e355f81bc15883a0e9011afc54d.svg";
export { ForwardRef as ReactComponent };